import { render, staticRenderFns } from "./UiFormInput.vue?vue&type=template&id=7068f9c3&"
import script from "./UiFormInput.vue?vue&type=script&lang=js&"
export * from "./UiFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports